+function ($) {

    'use strict';

    $(document).on('click', 'a[data-toggle="collapse"]', function (event) {
        var objectID = $(this).attr('href');

        if ($(this).hasClass('glyphicon-menu-down')) {
            $(this).removeClass('glyphicon-menu-down');
            $(this).addClass('glyphicon-menu-right');
        }
        else if ($(this).hasClass('glyphicon-menu-right')) {
            $(this).removeClass('glyphicon-menu-right');
            $(this).addClass('glyphicon-menu-down');
        }
    });

    $(document).on('click', '#collapseAll', function (event) {
        var divs = $('.panel-widgetHeading ');

        divs.find('a[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('href');
            $(objectID).removeClass('in');
            $(objectID).removeAttr('style');
            $(this).addClass('collapsed');
        });

        $(this).attr("style", "display:none");
        $("#expandAll").removeAttr("style");
    });

    $(document).on('click', '#expandAll', function (event) {
        var divs = $('.panel-widgetHeading ');

        divs.find('a[data-toggle="collapse"]').each(function() {
            var objectID = $(this).attr('href');
            $(objectID).addClass('in');
            $(objectID).removeAttr('style');
            $(this).removeClass('collapsed');
        });
        $(this).attr("style", "display:none");
        $("#collapseAll").removeAttr("style");
    });

    

    $(document).on('click', '#petitioncollapseAll', function (event) {
        var divs = $('.petition');

        divs.find('a[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('href');
            $(objectID).removeClass('in');
            $(objectID).removeAttr('style');
            $(this).addClass('collapsed');
        });

        $(this).attr("style", "display:none");
        $("#petitionexpandAll").removeAttr("style");
    });

    $(document).on('click', '#petitionexpandAll', function (event) {
        var divs = $('.petition');

        divs.find('a[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('href');
            $(objectID).addClass('in');
            $(objectID).removeAttr('style');
            $(this).removeClass('collapsed');
        });
        $(this).attr("style", "display:none");
        $("#petitioncollapseAll").removeAttr("style");
    });


    $(document).on('click', '#referralcollapseAll', function (event) {
        var divs = $('.referral');

        divs.find('a[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('href');
            $(objectID).removeClass('in');
            $(objectID).removeAttr('style');
            $(this).addClass('collapsed');
        });

        $(this).attr("style", "display:none");
        $("#referralexpandAll").removeAttr("style");
    });

    $(document).on('click', '#referralexpandAll', function (event) {
        var divs = $('.referral');

        divs.find('a[data-toggle="collapse"]').each(function () {
            var objectID = $(this).attr('href');
            $(objectID).addClass('in');
            $(objectID).removeAttr('style');
            $(this).removeClass('collapsed');
        });
        $(this).attr("style", "display:none");
        $("#referralcollapseAll").removeAttr("style");
    });


    $.fn.expand = function (object, expandobjectname) {
        $(expandobjectname).addClass('in');
        $(expandobjectname).removeAttr('style');
        $(object).removeClass('collapsed');
    }; 


    $.fn.collapse = function (object, collapseobjectname) {
        $(collapseobjectname).removeClass('in');
        $(collapseobjectname).removeAttr('style');
        $(object).addClass('collapsed');
    }; 


}(jQuery);
